import $api from 'http'
import $apiJSON from 'http/apiJSON'


export async function getAccountingData(data) {
  return $api.get(`/funds/`, data)
}

export async function DeleteFileData(id) {
  return $api.delete(`/document-accounting/${id}/`)
}

export async function getAccountingDetailData(id, data) {
  return $api.get(`/funds/${id}/`, data)
}

export async function PostAccounting(formdata) {
  return $api.post(`/funds/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function getReceiptsData(id, data) {
  return $api.get(`/funds-receipts/${id}/`, data)
}

export async function PostReceiptsData(id, formdata) {
  return $api.post(`/funds-receipts/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function DeleteReceiptsData(id) {
  return $api.delete(`/funds-receipts/${id}/`)
}

export async function PatchReceiptsData(id, formdata) {
  return $api.patch(`/funds-receipts/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}



export async function getExpensesData(id, data) {
  return $api.get(`/funds-expenses/${id}/`, data)
}

export async function PostExpensesData(id, formdata) {
  return $api.post(`/funds-expenses/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function DeleteExpensesData(id) {
  return $api.delete(`/funds-expenses/${id}/`)
}

export async function PatchExpensesData(id, formdata) {
  return $api.patch(`/funds-expenses/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export async function getCheckData(id, data) {
  return $api.get(`/funds-checks/${id}/`, data)
}

export async function PostCheckData(id, formdata) {
  return $api.post(`/funds-checks/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function DeleteCheckData(id) {
  return $api.delete(`/funds-checks/${id}/`)
}

export async function PatchCheckData(id, formdata) {
  return $api.patch(`/funds-checks/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}






// BRANCHES
export async function getBranchesData(id) {
  return $api.get(`/funds-branches/${id}/`);
}

export async function postBranchesData(id, formdata) {
  return $api.post(`/funds-branches/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchBranchesData(id, formdata) {
  return $api.patch(`/funds-branches/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteBranchesData(id) {
  return $api.delete(`/funds-branches/${id}/`);
}

// DEPARTMENTS
export async function getDepartmentsData(id) {
  return $api.get(`/funds-departments/${id}/`);
}

export async function postDepartmentsData(id, formdata) {
  return $api.post(`/funds-departments/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchDepartmentsData(id, formdata) {
  return $api.patch(`/funds-departments/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteDepartmentsData(id) {
  return $api.delete(`/funds-departments/${id}/`);
}

// SPECIALITIES
export async function getSpecialitiesData(id) {
  return $api.get(`/funds-specialities/${id}/`);
}

export async function postSpecialitiesData(id, formdata) {
  return $api.post(`/funds-specialities/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchSpecialitiesData(id, formdata) {
  return $api.patch(`/funds-specialities/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteSpecialitiesData(id) {
  return $api.delete(`/funds-specialities/${id}/`);
}

// GROUPS
export async function getGroupsData(id) {
  return $api.get(`/funds-groups/${id}/`);
}

export async function postGroupsData(id, formdata) {
  return $api.post(`/funds-groups/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchGroupsData(id, formdata) {
  return $api.patch(`/funds-groups/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteGroupsData(id) {
  return $api.delete(`/funds-groups/${id}/`);
}

// POSITIONS
export async function getPositionsData(id) {
  return $api.get(`/funds-positions/${id}/`);
}

export async function postPositionsData(id, formdata) {
  return $api.post(`/funds-positions/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchPositionsData(id, formdata) {
  return $api.patch(`/funds-positions/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deletePositionsData(id) {
   return $api.delete(`/funds-positions/${id}/`);
}
// ALLOWANCE CATEGORIES
export async function getAllowanceCategoriesData(id) {
  return $api.get(`/funds-allowance-categories/${id}/`);
}

export async function postAllowanceCategoryData(id, formdata) {
  return $api.post(`/funds-allowance-categories/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchAllowanceCategoryData(id, formdata) {
  return $api.patch(`/funds-allowance-categories/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteAllowanceCategoryData(id) {
  return $api.delete(`/funds-allowance-categories/${id}/`);
}

// DEDUCTION TYPES
export async function getDeductionTypesData(id) {
  return $api.get(`/funds-deduction-types/${id}/`);
}

export async function postDeductionTypeData(id, formdata) {
  return $api.post(`/funds-deduction-types/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchDeductionTypeData(id, formdata) {
  return $api.patch(`/funds-deduction-types/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteDeductionTypeData(id) {
  return $api.delete(`/funds-deduction-types/${id}/`);
}



// ACADEMIC YEARS
export async function getAcademicYearsData(id) {
  return $api.get(`/funds-academic-years/${id}/`);
}

export async function postAcademicYearsData(id, formdata) {
  return $api.post(`/funds-academic-years/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchAcademicYearsData(id, formdata) {
  return $api.patch(`/funds-academic-years/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteAcademicYearsData(id) {
  return $api.delete(`/funds-academic-years/${id}/`);
}

// EDUCATION TYPES
export async function getEducationTypesData(id) {
  return $api.get(`/funds-education-types/${id}/`);
}

export async function postEducationTypesData(id, formdata) {
  return $api.post(`/funds-education-types/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchEducationTypesData(id, formdata) {
  return $api.patch(`/funds-education-types/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteEducationTypesData(id) {
  return $api.delete(`/funds-education-types/${id}/`);
}

// COURSES
export async function getCoursesData(id) {
  return $api.get(`/funds-courses/${id}/`);
}

export async function postCoursesData(id, formdata) {
  return $api.post(`/funds-courses/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function patchCoursesData(id, formdata) {
  return $api.patch(`/funds-courses/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteCoursesData(id) {
  return $api.delete(`/funds-courses/${id}/`);
}

// CONTRACT AMOUNTS
export async function getContractAmountsData(year, department, type) {
  return $api.get(`/funds-contract-amounts/`, {
    params: {
      year,
      department,
      type,
    },
  });
}



export async function postContractAmountsData(formdata) {
  return $api.post(`/funds-contract-amounts/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}



export async function getStudentsData(id, data) {
  return $api.get(`/funds-students/${id}/`, data)
}


export async function getStudentsDetailData(id, data) {
  return $api.get(`/funds-students-detail/${id}/`, data)
}

export async function postStudentsData(id, formdata) {
  return $api.post(`/funds-students/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function PatchStudentsData(id, formdata) {
  return $api.patch(`/funds-students-detail/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function getStudentsHistoryData(id, data) {
  return $api.get(`/funds-students-history/${id}/`, data)
}

export async function getStudentsHistoryPayData(id, data) {
  return $api.get(`/funds-students-history-pay/${id}/`, data)
}


export async function PatchPaymentData(id, formdata) {
  return $api.patch(`/funds-students-history-pay/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export async function DeletePaymentData(id) {
  return $api.delete(`/funds-students-history-pay/${id}/`);
}

export async function getStudentsContractData(id, data) {
  return $api.get(`/funds-students-contract/${id}/`, data)
}

export async function postContractData(id, formdata) {
  return $api.post(`/funds-students-contract/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export async function getStudentsFilterData(specialitie, academicyear, educationtype, course) {
  return $api.get(`/funds-students-filter/`, {
    params: {
      specialitie,
      academicyear,
      educationtype,
      course
    },
  });
}

export async function postStudentsReleaseData(formdata) {
  return $api.post(`/funds-students-filter/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function postStudentsCourseForCouseData(formdata) {
  return $api.patch(`/funds-students-filter/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}



// Получить список сотрудников
export async function getEmployeesData(id) {
  return $api.get(`/funds-employees/${id}/`);
}

// Получить детальную информацию о сотруднике
export async function getEmployeeDetailData(id) {
  return $api.get(`/funds-employees-detail/${id}/`);
}

// Изменить данные сотрудника (PATCH)
export async function PatchEmployeeData(id, formdata) {
  return $api.patch(`/funds-employees-detail/${id}/`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// Получить историю сотрудника
export async function getEmployeeHistoryData(id) {
  return $api.get(`/funds-employees-history/${id}/`);
}

export async function getAllowanceCategories(id) {
  return $api.get(`/funds-allowance-categories/${id}/`);
}
export async function getDeductionTypes(id) {
  return $api.get(`/funds-deduction-types/${id}/`);
}

export async function getEmployeeHistoryPayData(id) {
  return $api.get(`/funds-employees-history-pay/${id}/`);
}

export async function StatusChangeData(id) {
  return $api.patch(`/funds-employees-history-pay/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
export async function getEmployeeSalaryPayData(id) {
  return $api.get(`/funds-employees-salary-pay/${id}/`);
}
export async function StatusChangeSalaryData(id) {
  return $api.patch(`/funds-employees-salary-pay/${id}/`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

